import React from "react";
import { ICallingDisposition } from "@vahak/core/dist/custom-types";
import Flex from "@vahak/core-ui/dist/layout/Flex";
import BordererCard from "@vahak/core-ui/dist/components/common/BordererCard/BordererCard";
import { generateSelectOption } from "../../../../methods/uiUtil";
import Typography from "@vahak/core-ui/dist/components/Typography";
import DotSeparatedList from "@vahak/core-ui/dist/components/common/DotSeparatedList/DotSeparatedList";
import COLORS from "@vahak/core-ui/dist/constants/colors";
import { formatDate } from "@vahak/core-ui/dist/methods/time";
import PostingChip from "../../../posting-form/common/posting-chip/PostingChip";
import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";
import { stringOperations } from "@vahak/core-ui/dist/methods";

interface DispositionCardProps {
    data?: ICallingDisposition;
    fullWidth?: boolean;
}

const DispositionCard = ({ data, fullWidth = false }: DispositionCardProps) => {
    const isMobileScreen = useMediaQuery({ queryType: "mobile" });
    const list = [
        generateSelectOption("Status", `Status: ${data?.status}`, data?.status),
        generateSelectOption("Disposition", `Disposition: ${data?.disposition}`, data?.disposition),
        generateSelectOption("Sub-Disposition", `Sub-Disposition: ${data?.sub_disposition}`, data?.sub_disposition),
        generateSelectOption("Closing", `Closing: ${data?.closing}`, data?.closing),
        ...Object.entries(data?.dispositions_data?.disposition_information ?? {}).map(([key, value]) => {
            const label = stringOperations(key, ["capitalizeEachWord", "replaceUnderscoreWithSpace"]);
            return generateSelectOption(label, `${label}: ${value}`, value);
        })
    ];
    return (
        <BordererCard width={isMobileScreen || fullWidth ? "100%" : 1000}>
            <Flex flexDirection="column" gap={16}>
                <Typography weight="medium" color={COLORS.GREY_600}>
                    <DotSeparatedList
                        items={[
                            {
                                node: <Typography>Updated By {data?.created_by_name}</Typography>,
                                id: "created_by_name"
                            },
                            {
                                node: (
                                    <Typography>
                                        {formatDate(new Date(data?.created_at ?? "-"), "MMMM DD, YYYY at h:mm a")}
                                    </Typography>
                                ),
                                id: "created_at"
                            }
                        ]}
                    />
                </Typography>
                <Flex gap={8} flexWrap="wrap">
                    {list
                        ?.filter((val) => !!val?.id)
                        .map((item, ix) => (
                            <PostingChip key={item?.label} weight="medium">
                                {item?.value}
                            </PostingChip>
                        ))}
                </Flex>
                <Typography weight="medium" color={COLORS.GREY_600}>
                    {data?.other ? `Remarks: ${data?.other}` : ""}
                </Typography>
            </Flex>
        </BordererCard>
    );
};

export default DispositionCard;
